(() => {
  const READY = "emptyNavReady";

  const movePill = (root) => {
    const tabsWrap = root.querySelector(".cart-empty-nav__tabs");
    const pill = tabsWrap && tabsWrap.querySelector(".cart-empty-nav__pill");
    const activeTab = tabsWrap && tabsWrap.querySelector(".cart-empty-nav__tab.is-active");
    if (!pill || !activeTab) return;

    const tabRect = activeTab.getBoundingClientRect();
    const wrapRect = tabsWrap.getBoundingClientRect();
    // The drawer is display:none while closed, so nothing is measurable until it opens.
    if (!tabRect.width || !wrapRect.width) return;

    pill.style.width = `${tabRect.width}px`;
    pill.style.transform = `translateX(${tabRect.left - wrapRect.left}px)`;
  };

  const setActive = (root, key) => {
    root.setAttribute("data-active-tab", key);

    root.querySelectorAll("[data-empty-tab]").forEach((btn) => {
      const isOn = btn.getAttribute("data-empty-tab") === key;
      btn.classList.toggle("is-active", isOn);
      btn.setAttribute("aria-selected", isOn ? "true" : "false");
      btn.tabIndex = isOn ? 0 : -1;
    });

    root.querySelectorAll("[data-empty-panel]").forEach((panel) => {
      const isOn = panel.getAttribute("data-empty-panel") === key;
      panel.setAttribute("aria-hidden", isOn ? "false" : "true");
    });

    movePill(root);
  };

  const eachNav = (fn) => document.querySelectorAll("[data-cart-empty-nav]").forEach(fn);

  const recalcAll = () => requestAnimationFrame(() => eachNav(movePill));

  const init = (root) => {
    if (root.dataset[READY]) return;
    root.dataset[READY] = "true";

    setActive(root, root.getAttribute("data-default-tab") || "women");
    requestAnimationFrame(() => movePill(root));
    setTimeout(() => movePill(root), 250);
  };

  const initAll = () => eachNav(init);

  document.addEventListener("click", (event) => {
    const tab = event.target.closest && event.target.closest("[data-empty-tab]");
    const root = tab && tab.closest("[data-cart-empty-nav]");
    if (root) setActive(root, tab.getAttribute("data-empty-tab"));
  });

  window.addEventListener("resize", recalcAll);

  const start = () => {
    initAll();

    const drawer = document.getElementById("MinimogCartDrawer");
    if (!drawer) return;

    // Catches the empty state arriving from any re-render path, whoever triggered it.
    new MutationObserver(initAll).observe(drawer, { childList: true, subtree: true });

    if (window.MinimogEvents && window.MinimogTheme) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, recalcAll);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recalcAll).catch(() => {});
    }
  };

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start();
})();
